module.exports = __webpack_public_path__ + "static/flags/BO-5eeb86b4ce30a4422f2540c42f756170.gif";